import data from "utils/configuratorNewStyle.json";
import { configuratorTrackEvent } from "utils/analytics";
import en from "../translations/translation-website.en.json";

export const initialSelection = (code) => {
  if (code) {
    return decompressSelection(code);
  }
  const selection = {};
  data.steps[0].options.forEach((option) => {
    selection[option.id] = option.values[0];
  });
  data.steps[1].options.forEach((option) => {
    selection[option.id] = option.values[0];
  });
  data.steps[2].options.forEach((option) => {
    if (
      option.type === "select" ||
      option.type === "big_select" ||
      option.type === "model_select"
    ) {
      selection[option.id] = option.values[0];
    }
  });
  return selection;
};

export const compressSelection = (selection) => {
  const selectionKeys = Object.keys(selection);
  const minify = {};
  selectionKeys.forEach((key) => {
    if (selection[key] && selection[key].id != null) {
      minify[key] = selection[key].id;
    } else if (Array.isArray(selection[key])) {
      minify[key] = selection[key].map((item) => item.id);
    }
  });

  const objJsonB64 = Buffer.from(JSON.stringify(minify)).toString("base64");
  return objJsonB64;
};

export const decompressSelection = (code) => {
  if (code == null) {
    return initialSelection();
  }
  try {
    const selection = JSON.parse(Buffer.from(code, "base64").toString("utf-8"));
    const selectionKeys = Object.keys(selection);

    selectionKeys.forEach((key) => {
      data.steps.forEach((step) => {
        if (step.options && step.options.length > 0) {
          step.options.forEach((option) => {
            if (option.id === key) {
              if (Array.isArray(selection[key])) {
                selection[key].forEach((id, idx) => {
                  selection[key][idx] = option.values[id];
                });
              } else {
                selection[key] = option.values[selection[key]];
              }
            }
          });
        }
      });
    });

    return selection;
  } catch (_error) {
    return initialSelection();
  }
};

export const getBasePrice = (selection) => {
  const modelId = selection?.m?.id ?? 0;
  const basePrice =
    modelId === 1 ? process.env.hc50_base_price : process.env.hx50_base_price;
  return (parseInt(basePrice) || 0) * 1000;
};

export const getModelName = (selection) =>
  selection?.m?.id === 1 ? "HC50" : "HX50";

export const getCost = (selection) => {
  let cost = getBasePrice(selection);
  Object.keys(selection).forEach((option) => {
    if (Array.isArray(selection[option])) {
      selection[option].forEach((value) => {
        if (value) {
          cost += value.cost;
        }
      });
    } else if (selection[option]) {
      cost += selection[option].cost;
    }
  });
  return cost;
};

export const getStep = (queryStep) => {
  const parsed = parseInt(queryStep, 10);
  return parsed >= 0 && parsed < data.steps.length ? parsed : 0;
};

const imagePath = "/images/configurator/";
const imageExtension = ".jpg";

export const getImageUrl = (index, selection) => {
  const selectionKeys = Object.keys(selection);
  let imgUrl = `${imagePath}`;

  data.images[index].variants.forEach((variant) => {
    let key = null;
    if (variant === "optionId") {
      key = "s";
    } else {
      key = selectionKeys.find((e) => selection[e][variant] !== undefined);
    }
    if (key && key !== "s") {
      imgUrl = `${imgUrl}${variant.slice(0, -2)}${selection[key][variant]}-`;
    } else if (key === "s" && selection[key] && selection[key].id === 1) {
      imgUrl = `${imgUrl}${variant.slice(0, -2)}${selection[key].id}-`;
    }
  });
  return `${imgUrl}image${data.images[index].id}${imageExtension}`;
};

const ACTION_BY_STEP = {
  0: "Colour Select",
  1: "Interior Select",
  2: "Options Select",
};

export const trackNextBt = (step, selection) => {
  try {
    if (step === 3) return;

    let label = "";
    let value = 1;

    Object.keys(selection).forEach((key) => {
      if (Array.isArray(selection[key]) && step === 2) {
        selection[key].forEach((option) => {
          label = label.concat(`${en[option.title]}, `);
        });

        label = label.slice(0, -2);
      } else if (
        selection[key] &&
        selection[key].step === step &&
        key !== "a" &&
        key !== "m"
      ) {
        label = en[selection[key].title];
        value = selection[key].id;
      }
    });

    const action = ACTION_BY_STEP[step] ?? "";
    configuratorTrackEvent(action, label, parseInt(value, 10));
  } catch (error) {
    console.log("$$$ Analytics Error: ", error);
  }
};

export const trackSelection = (value) => {
  try {
    const action = value.interiorId ? "Interior Selection" : "Colour Selection";
    configuratorTrackEvent(action, en[value.title], value.id);
  } catch (error) {
    console.log("$$$ Analytics Error: ", error);
  }
};

export const trackOption = (value) => {
  try {
    configuratorTrackEvent("Options Selection", en[value.title], value.id);
  } catch (error) {
    console.log("$$$ Analytics Error: ", error);
  }
};

export const trackTooltip = (value) => {
  try {
    configuratorTrackEvent("Tooltip", en[value.title], value.id);
  } catch (error) {
    console.log("$$$ Analytics Error: ", error);
  }
};
